import { createFileRoute } from "@tanstack/react-router";
import { FoundingMembershipCTA } from "@/components/FoundingMembershipCTA";

export const Route = createFileRoute("/welcome")({
  head: () => ({
    meta: [
      { title: "Membership — Recovery Trauma™" },
      {
        name: "description",
        content:
          "Recovery Trauma™ is live. Start your Membership and get immediate access.",
      },
      { property: "og:title", content: "Membership — Recovery Trauma™" },
      {
        property: "og:description",
        content:
          "Recovery Trauma™ is live. Start your Membership and get immediate access.",
      },
      { property: "og:url", content: "https://recoverytrauma.com/welcome" },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex,nofollow" },
    ],
    links: [{ rel: "canonical", href: "https://recoverytrauma.com/welcome" }],
  }),
  component: WelcomePage,
});

function WelcomePage() {
  return (
    <div className="min-h-[100svh] bg-gradient-to-b from-background via-background to-[var(--gold-soft)]/25 px-4 py-16 sm:py-24">
      <h1 className="mb-8 text-center font-serif text-3xl tracking-tight text-foreground sm:text-4xl">
        Welcome to Recovery Trauma™
      </h1>
      <div className="mx-auto flex max-w-3xl items-center justify-center">
        <FoundingMembershipCTA ctaHref="/signup" decideLaterHref="/" />
      </div>
    </div>
  );
}
